import { configureStore } from '@reduxjs/toolkit';
import tabsReducer from "../features/tabs/tabsSlice";
import productsReducer from "../features/products/productsSlice";
const store = configureStore({
    reducer: {
        tabs: tabsReducer,
        products: productsReducer
    },
});
export default store;
